import { curveColorDarkRecord, curveColorLightRecord } from '../../curvePalette';
import type { CurvePaletteKey } from '../../curvePalette';

import styles from './CurveColorPalette.module.css';

type CurveColorPaletteProps = {
  theme: 'dark' | 'light';
  value: CurvePaletteKey;
  onChange: (color: CurvePaletteKey) => void;
  getColorLabel: (number: number) => string;
};

export function CurveColorPalette({ theme, value, onChange, getColorLabel }: CurveColorPaletteProps) {
  const colors = theme === 'dark' ? curveColorDarkRecord : curveColorLightRecord;
  return (
    <div className={styles.palette}>
      {Object.entries(colors).map(([key, color], index) => (
        <button
          key={key}
          type="button"
          className={styles.color}
          style={{ backgroundColor: color }}
          aria-label={getColorLabel(index + 1)}
          aria-pressed={key === value}
          onClick={() => onChange(key as CurvePaletteKey)}
        />
      ))}
    </div>
  );
}
